




































import { transferBalanceMixin } from '@/utils/mixins/transferBalanceMixin'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface';

export default transferBalanceMixin.extend({
  data() {
    return {
      DeliveryCurrenciesEnum,
    }
  },
})
